<template>
  <div>
    <div class="frame-container">
      <div class="info-panel">
        <div class="info-panel-container">
          <div class="info-panel-item">
            <div class="info-panel-item__section">
              <em class="fas fa-address-book" />
              <span>SIE:</span>
            </div>
            <label>{{ studentInfo.studentSieId }}</label>
          </div>
          <div class="info-panel-item">
            <div class="info-panel-item__section">
              <em class="fas fa-address-book" />
              <span>Estudiante:</span>
            </div>
            <label>
              {{ studentInfo.studentName }}
            </label>
          </div>
          <div class="info-panel-item">
            <div class="info-panel-item__section">
              <em class="fas fa-calendar-edit" />
              <span>Edad:</span>
            </div>
            <label>{{ studentInfo.studentAge }} años</label>
          </div>
          <div class="info-panel-item">
            <div class="info-panel-item__section">
              <em class="fas fa-ballot-check" />
              <span>Impedimento:</span>
            </div>
            <label>{{ studentInfo.impedimentName }}</label>
          </div>
        </div>
      </div>
      <div class="ml-4 mt-4">
        <educative-additional-info
          v-if="studentInfo.isEducativeService"
          :assignment-end-date="dateFormat(studentInfo.assignmentEndDate)"
          :assignment-start-date="dateFormat(studentInfo.assignmentStartDate)"
          :value="studentInfo.educationServiceInfo || {}"
        />
      </div>

      <div v-if="!studentInfo.isEducativeService">
        <div
          v-for="(srv, index) in referrals"
          :key="'student-srv' + index"
          class="row p-3 mx-3"
        >
          <div class="col">
            <div class="legend">
              Tipo de Servicio:
            </div>
            <div class="font-weight-normal text-black">
              {{ srv.disciplineName }}
            </div>
          </div>
          <div class="col">
            <div class="legend">
              Modalidad:
            </div>
            <div class="font-weight-normal text-black">
              {{ srv.modality }}
            </div>
          </div>
          <div class="col">
            <div class="legend">
              Frecuencia:
            </div>
            <div class="font-weight-normal text-black">
              {{ srv.frequency }}
            </div>
          </div>
          <div class="col">
            <div class="legend">
              Duración:
            </div>
            <div class="font-weight-normal text-black">
              {{ srv.duration }}
            </div>
          </div>
          <div class="col">
            <div class="legend">
              Vigencia:
            </div>
            <div class="font-weight-normal text-black">
              {{ srv.effectiveDateFrom }} - {{ srv.effectiveDateTo }}
            </div>
          </div>
        </div>
        <div v-if="compensatoryInfo" class="row p-3 mx-3">
          <div class="col">
            <div class="legend">
              Número de Solicitud:
            </div>
            <div class="font-weight-normal text-black">
              {{ compensatoryInfo.requestNumber }}
            </div>
          </div>
          <div class="col">
            <div class="legend">
              Tipo de Solicitud:
            </div>
            <div class="font-weight-normal text-black">
              {{ compensatoryInfo.requestType }}
            </div>
          </div>
          <div class="col">
            <div class="legend">
              Cantidad Intervenciones:
            </div>
            <div class="font-weight-normal text-black">
              {{ compensatoryInfo.interventionAmount || '-' }}
            </div>
          </div>
          <div class="col" />
          <div class="col" />
        </div>

        <div
          v-if="referrals.length == 0"
          class="d-flex justify-content-center align-items-center"
        >
          <p class="color-secondary-20 mt-3 font-18">
            Este referido no cuenta con vigencia.
          </p>
        </div>
      </div>
      <referral-navigation
        v-if="referralCount > 1"
        :page="referralCurrentPage"
        :size="referralCount"
        @on-change-page="$emit('on-change-page', $event)"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ReferralNavigation from './ReferralNavigation.vue';
import EducativeAdditionalInfo from '@/components/common/visits/EducativeAdditionalInfo';
export default {
  name: 'VisitRegistryAdditionalInfo',
  components: {
    ReferralNavigation,
    EducativeAdditionalInfo,
  },
  props: {
    studentInfo: {
      type: Object,
      default: () => {},
    },
    referrals: {
      type: Array,
      default: () => [],
    },
    compensatoryInfo: {
      type: Object,
      default: () => {},
    },
    referralCurrentPage: {
      type: Number,
      default: () => 1,
    },
    referralCount: {
      type: Number,
      default: () => 0,
    },
  },
  methods: {
    dateFormat: function(date) {
      if (date) {
        return moment(date)
          .locale('es-PR')
          .format('DD/MMM/YYYY');
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
$collapseOpenColor: #bcbec0;
$collapseCloseColor: #ff7058;
$colorWhite: #fff;
$panelBorderColor: #f2f2f2;

.frame-container {
  background: #f2f2f2;
  border-radius: 5px;
  padding: 10px;

  .legend {
    text-align: left;
    font: Regular 14px/28px Lato;
    letter-spacing: 0px;
    color: #727272;
  }

  .info-panel {
    background: #fff;
    padding: 15px 10px 1px 20px;
    border-radius: 5px;
    opacity: 1;
    .info-panel-main-title {
      em {
        color: $collapseCloseColor;
      }
      span {
        text-align: left;
        font: Bold 16px/19px Lato;
        letter-spacing: 0px;
        color: #3f5b60;
        opacity: 1;
        margin-left: 7px;
      }
    }
    .info-panel-container {
      display: flex;
      flex-flow: row wrap;
      padding: 0px 10px 0px 23px;
      .info-panel-item {
        display: flex;
        flex-direction: column;
        flex: 1 0 25%;
        margin-bottom: 0.3em;
        float: left;
        box-sizing: border-box;
        padding-right: 10px;

        &__section {
          display: flex;
          flex-direction: row;
          align-items: center;
          em {
            color: #ff7058;
            margin-right: 10px;
          }
        }
        span {
          display: block;
          text-align: left;
          font: Regular 14px/28px Lato;
          letter-spacing: 0px;
          color: #727272;
        }
        label {
          margin-top: 0px;
          margin-left: 23px;
          text-align: left;
          font: Regular Lato;
          font-size: 1rem;
          letter-spacing: 0px;
          color: #11291b;
          line-height: 1.6em;
        }
      }
    }
  }
}

.text-black {
  color: #11291b;
}
</style>
